import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { PasswordResetSuccessComponent } from './auth/password-reset-success/password-reset-success.component';
import { ResetPasswordLinkComponent } from './auth/reset-password-link/reset-password-link.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { AssignmentsComponent } from './components/assignments/assignments.component';
import { CreateAssignmentComponent } from './components/assignments/create-assignment/create-assignment.component';
import { Step1Component } from './components/assignments/create-assignment/step1/step1.component';
import { Step2Component } from './components/assignments/create-assignment/step2/step2.component';
import { Step3Component } from './components/assignments/create-assignment/step3/step3.component';
import { CompanyComponent } from './components/company/company.component';
import { UsersComponent } from './components/company/users/users.component';
import { ComponentsComponent } from './components/components.component';
import { ReportTypesComponent } from './components/reports/report-types/report-types.component';
import { ReportComponent } from './components/reports/report/report.component';
import { ReportsDetailsComponent } from './components/reports/reports-details/reports-details.component';
import { ReportsComponent } from './components/reports/reports.component';
import { preventLoggedInGuard } from './guards/prevent-logged-in.guard';
import { authEmployeeGuard } from './guards/auth-employee.guard';
import { AcceptInviteComponent } from "./components/company/accept-invite/accept-invite.component";
import { EmployeeResolverResolver } from "./components/employee-resolver.resolver";
import { onboardingAssignmentGuard } from './guards/onboardingAssignment.guard';
import { QualityModeComponent } from './components/quality-mode/quality-mode.component';
import { onboardingGuard } from './guards/onboarding.guard';
import { OnboardingComponent } from './components/onboarding/onboarding.component';
import { DownloadAppComponent } from './download-app/download-app.component';
import { PaymentCallbackComponent } from './components/payment/payment-callback/payment-callback.component';

const routes: Routes = [
    { path: '', component: LandingComponent, canActivate: [preventLoggedInGuard] },
    { path: 'download', component: DownloadAppComponent, canActivate: [preventLoggedInGuard] },
    { path: 'login', component: LoginComponent, canActivate: [preventLoggedInGuard] },
    { path: 'register', component: RegisterComponent, canActivate: [preventLoggedInGuard] },
    { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [preventLoggedInGuard] },
    { path: 'password-reset-success', component: PasswordResetSuccessComponent, canActivate: [preventLoggedInGuard] },
    { path: 'reset-password-link', component: ResetPasswordLinkComponent, canActivate: [preventLoggedInGuard] },
    { path: 'reset-password', component: ResetPasswordComponent, canActivate: [preventLoggedInGuard] },
    { path: 'accept-invite', component: AcceptInviteComponent, canActivate: [preventLoggedInGuard] },
    { path: 'payment/callback', component: PaymentCallbackComponent, canActivate: [authEmployeeGuard] },
    {
        path: 'components',
        component: ComponentsComponent,
        children: [
            { path: 'on-boarding', component: OnboardingComponent, resolve: [EmployeeResolverResolver], canActivate: [authEmployeeGuard, onboardingGuard] },
            { path: 'assignments', component: AssignmentsComponent, resolve: [EmployeeResolverResolver], canActivate: [onboardingAssignmentGuard], runGuardsAndResolvers: 'paramsOrQueryParamsChange' },
            {
                path: 'assignments/create-assignment', component: CreateAssignmentComponent, canActivate: [authEmployeeGuard], children: [
                    { path: 'step1', component: Step1Component, resolve: [EmployeeResolverResolver], canActivate: [onboardingAssignmentGuard] },
                    { path: 'step2', component: Step2Component, resolve: [EmployeeResolverResolver], canActivate: [onboardingAssignmentGuard] },
                    { path: 'step3', component: Step3Component, resolve: [EmployeeResolverResolver], canActivate: [onboardingAssignmentGuard] },
                ]
            },
            {
                path: 'company', component: CompanyComponent, canActivate: [authEmployeeGuard], children: [
                    { path: 'users', component: UsersComponent, resolve: [EmployeeResolverResolver], canActivate: [onboardingAssignmentGuard] },
                ]
            },
            {
                path: 'reports', component: ReportsComponent, canActivate: [authEmployeeGuard], children: [
                    { path: 'reports-details', component: ReportsDetailsComponent, resolve: [EmployeeResolverResolver] },
                    { path: 'report/:id', component: ReportComponent, resolve: [EmployeeResolverResolver] },
                    { path: 'report-types', component: ReportTypesComponent }
                ]
            },
            { path: 'quality-mode', component: QualityModeComponent, canActivate: [authEmployeeGuard, onboardingAssignmentGuard] }

        ]
    },
    { path: '**', redirectTo: '', canActivate: [authEmployeeGuard] } // Use authEmployeeGuard to decide where to redirect
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'top',
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
